document.addEventListener("DOMContentLoaded", () => {
  const mtgtwbookingData = JSON.parse(
    document.getElementById("mtgtwbookingData").textContent,
  );
  const productSelectedVariant = mtgtwbookingData.productSelectedVariant;
  const appointmentTypeId = mtgtwbookingData.appointmentTypeId;

  const availabilityUrl =
    "https://app.learnpac.co.uk/wp-json/shopify/v1/appointment-types/" +
    appointmentTypeId +
    "/availability?type=3";

  const availabilityLists = document.querySelectorAll("#availability-list");

  if (!availabilityLists.length) {
    return;
  }

  async function renderAvailability() {
    try {
      const response = await fetch(availabilityUrl);

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      const items =
        Array.isArray(data) ? data
        : Array.isArray(data?.items) ? data.items
        : Array.isArray(data?.data) ? data.data
        : [];

      const blockedDates = [];

      const normalizedItems = items.map((item) => {
        if (blockedDates.includes(item.date)) {
          return {
            ...item,
            available_seats: 0,
            total_seats: 0,
          };
        }

        return item;
      });

      availabilityLists.forEach((availabilityList) => {
        availabilityList.innerHTML = "";
      });

      if (!normalizedItems.length) {
        availabilityLists.forEach((availabilityList) => {
          availabilityList.innerHTML = `
          <p class="mtgtw:py-5!">
            No availability found.
          </p>
        `;
        });
        return;
      }

      availabilityLists.forEach((availabilityList) => {
        normalizedItems.forEach((item) => {
          const row = document.createElement("div");
          row.className =
            "mtgtw:grid! mtgtw:grid-cols-32! mtgtw:grid-rows-auto! mtgtw:gap-1! mtgtw:w-full! mtgtw:gap-1! mtgtw:py-3! mtgtw:pr-2! mtgtw:border-[#E0E0E0] mtgtw:border-t! mtgtw:transition-opacity mtgtw:group-hover:opacity-50 mtgtw:hover:opacity-100!";

          const timeSlot = item.timeSlots?.[0] || "";
          const availableSeats = Number(item.available_seats || 0);
          const quantityOptions = Array.from(
            { length: availableSeats },
            (_, index) => {
              const value = index + 1;
              return `<option value="${value}">${value}</option>`;
            },
          ).join("");

          row.innerHTML = `
          <div class="mtgtw:w-full! mtgtw:col-span-12! mtgtw:min-[1250px]:col-span-10! mtgtw:min-[1300px]:col-span-12! mtgtw:min-[1490px]:col-span-10! mtgtw:flex! mtgtw:items-center! mtgtw:justify-start!">
            <div>
              <p class="mtgtw:text-base! mtgtw:min-[400px]:text-xl! mtgtw:font-bold! mtgtw:font-mtgmontserrat! mtgtw:text-primary!">
                ${item.date}
              </p>
              <p class="mtgtw:text-base! mtgtw:min-[400px]:text-lg! mtgtw:font-semibold! mtgtw:font-mtgmontserrat! mtgtw:text-primary!">
                ${timeSlot} - 4:30pm
              </p>
            </div>
          </div>

          <div class="mtgtw:col-span-14! mtgtw:min-[1250px]:col-span-8! mtgtw:min-[1300px]:col-span-14! mtgtw:min-[1490px]:col-span-8! mtgtw:flex! mtgtw:items-center! mtgtw:justify-center!">
            <p class="mtgtw:text-2xl! mtgtw:font-bold! mtgtw:font-mtgmontserrat! mtgtw:text-primary! mtgtw:flex! mtgtw:min-[1490px]:items-center! mtgtw:gap-2! mtgtw:text-nowrap!">
              ${availableSeats}
            </p>
          </div>

          <div class="mtgtw:flex! mtgtw:items-center! mtgtw:min-[1490px]:justify-center! mtgtw:justify-end! mtgtw:col-span-6! mtgtw:min-[1250px]:col-span-5! mtgtw:min-[1300px]:col-span-6! mtgtw:min-[1490px]:col-span-5! ${availableSeats === 0 ? "mtgtw:invisible!" : "mtgtw:visible!"}">
            <div class="mtgtw:relative!">
              <select
                data-quantity-select
                class="mtgtw:border! mtgtw:border-[#E0E0E0]! mtgtw:h-[32px]! mtgtw:w-[40px]! mtgtw:bg-[#F6F6F6]! mtgtw:rounded-xl! mtgtw:px-2! mtgtw:text-start! mtgtw:font-mtgmontserrat! mtgtw:text-primary! mtgtw:font-semibold!"
                ${availableSeats === 0 ? "disabled" : ""}
              >
                ${quantityOptions}
              </select>
        
              <svg
                class="mtgtw:pointer-events-none! mtgtw:absolute! mtgtw:right-4! mtgtw:top-1/2! mtgtw:-translate-y-1/2! mtgtw:w-5! mtgtw:h-5! mtgtw:text-primary!"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m19 9-7 7-7-7"
                />
              </svg>
            </div>
          </div>

          <div class="mtgtw:col-span-32! mtgtw:min-[1250px]:col-span-9! mtgtw:min-[1300px]:col-span-32! mtgtw:min-[1490px]:col-span-9! mtgtw:flex! mtgtw:items-center! mtgtw:justify-end!">
            <button
              type="button"
              data-date="${item.date}"
              data-timeslot="${timeSlot}"
              data-variant-id="${productSelectedVariant}"
              data-available-seats="${availableSeats}"
              class="mtgtw:py-2! mtgtw:px-2! mtgtw:w-full! mtgtw:h-full! mtgtw:rounded-full! mtgtw:leading-normal! mtgtw:text-lg! mtgtw:font-mtgmontserrat! mtgtw:font-semibold! mtgtw:text-nowrap! ${availableSeats === 0 ? "mtgtw:bg-red-700! mtgtw:text-white!" : "mtgtw:bg-secondary! mtgtw:text-white!"}"
              ${availableSeats === 0 ? "disabled" : ""}
            >
              ${availableSeats === 0 ? "FULLY BOOKED" : "BOOK NOW"}
            </button>
          </div>
        `;

          const button = row.querySelector("button");
          const quantitySelect = row.querySelector("[data-quantity-select]");

          if (button && !button.disabled) {
            button.addEventListener("click", async () => {
              button.textContent = "BOOKING...";
              button.disabled = true;

              const allButtons = availabilityList.querySelectorAll(
                "button[data-variant-id]",
              );
              allButtons.forEach((candidate) => {
                if (candidate !== button) {
                  candidate.disabled = true;
                }
              });

              const quantity = Number.parseInt(
                quantitySelect?.value || "1",
                10,
              );
              const safeQuantity =
                Number.isNaN(quantity) || quantity < 1 ?
                  1
                : Math.min(
                    quantity,
                    Number(button.dataset.availableSeats || 1),
                  );

              const bookingData = {
                id: Number(button.dataset.variantId),
                quantity: safeQuantity,
                properties: {
                  Date: button.dataset.date,
                  Timeslot: button.dataset.timeslot,
                },
              };

              try {
                await fetch("/cart/clear.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                });

                await fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({ items: [bookingData] }),
                });

                window.location.href = "/checkout";
              } catch (error) {
                console.error("Booking / single-checkout error:", error);
              }
            });
          }

          availabilityList.appendChild(row);
        });
      });
    } catch (error) {
      console.error("Failed to load availability:", error);

      availabilityLists.forEach((availabilityList) => {
        availabilityList.innerHTML = `
          <p class="mtgtw:py-5!">
            Unable to load availability.
          </p>
        `;
      });
    }
  }

  renderAvailability();
});
